import axios from "axios";
import Notifications from 'react-notification-system-redux';
import {change, untouch} from 'redux-form';
import { GET_COMMENTS, ROOT_URL, POSTING, COMPLETED, UPDATE_TRANSACTIONS } from "./types";

export function getComments(bookId, bankDataGUID) {
  return function (dispatch) {
    axios.get(`${ROOT_URL}/books/${bookId}/transaction/${bankDataGUID}/comments/`,
      { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
      .then(response => {
        const payload = response.data.body.comments.comments;
        dispatch({ type: GET_COMMENTS, payload });
      })
      .catch((error) => {
        console.log('getComments error: ', error);
        dispatch(Notifications.warning({ message: 'Could not fetch comments' }));
      });
  };
}

export function postComment(comment, bookId, transaction) {
  return function (dispatch) {
    dispatch({ type: POSTING });
    axios.post(`${ROOT_URL}/books/${bookId}/transaction/${transaction.BankDataGUID}/comments/`, comment,
      { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
      .then(() =>
        axios.get(`${ROOT_URL}/books/${bookId}/transaction/${transaction.BankDataGUID}/comments/`,
          { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } }))
      .then(response => {
        dispatch({ type: GET_COMMENTS, payload: response.data.body.comments.comments });
        dispatch({ type: COMPLETED, payload: true });
        dispatch(Notifications.success({ message: 'Comment Saved' }));
        dispatch({ type: UPDATE_TRANSACTIONS, payload: { ...transaction, Comments: transaction.Comments + 1 } });
        dispatch(change('commentEdit', 'comment', null))
        dispatch(untouch('commentEdit', 'comment'));
      })
      .catch(() => {
        dispatch({ type: COMPLETED, payload: false });
        dispatch(Notifications.warning({ message: 'Unable to save comment' }));
      });
  };
}

export function deleteComment(commentId, transaction, bookId, comments) {
  return function (dispatch) {
    axios.delete(`${ROOT_URL}/books/${bookId}/transaction/${transaction.BankDataGUID}/comments/${commentId}`,
      { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
      .then(response => {
        dispatch({ type: GET_COMMENTS, payload: comments.filter(comment => comment.BankDataCommentId !== commentId) });
        dispatch({ type: COMPLETED, payload: true });
        dispatch(Notifications.success({ message: 'Comment Deleted' }));
        dispatch({ type: UPDATE_TRANSACTIONS, payload: { ...transaction, Comments: transaction.Comments - 1 } });
      })
      .catch(() => {
        dispatch({ type: COMPLETED, payload: false });
        dispatch(Notifications.warning({ message: 'Unable to delete comment' }));
      });
  };
}


// WEBPACK FOOTER //
// ./src/Actions/comments.js